import { ChoosePCPAlert } from '../../../../common/Alert/ChoosePCPAlert';
import { EAPCode } from '../../../../common/EAPCode';
import { ErrorBoundary } from '../../../../errors/ErrorBoundary';
import { uhcThemeOverride } from '../../../../frontends/themeOverrides/uhcThemeOverride';
import { ExpandedSearchRadiusBanner } from '../MapView/ExpandedSearchRadiusBanner';
import { EAPStyle } from '../MapView/MapView.styled';
import { AlertBannerWrapper } from './ViewAll.style';

interface Props {
  enableMapViewEnhancements: boolean;
  showAlerts: boolean;
  enableMapViewHideOption: boolean;
  expandedProviderListView: boolean;
  navigateToDirections: boolean;
  eapCodeFlag: boolean;
  isBHCare: boolean;
}

export const AlertsContent = ({
  eapCodeFlag,
  enableMapViewEnhancements,
  enableMapViewHideOption,
  isBHCare,
  navigateToDirections,
  expandedProviderListView,
  showAlerts,
}: Props) => {
  if (enableMapViewEnhancements && showAlerts) {
    if (enableMapViewHideOption) {
      if (expandedProviderListView && navigateToDirections) {
        return null;
      } else {
        return (
          <div
            style={{
              backgroundColor: uhcThemeOverride.theme.colors.bgHeaderColor,
            }}
          >
            <ErrorBoundary>
              <AlertBannerWrapper>
                <ChoosePCPAlert />
                <ExpandedSearchRadiusBanner />
                {eapCodeFlag && isBHCare && (
                  <EAPStyle>
                    <EAPCode />
                  </EAPStyle>
                )}
              </AlertBannerWrapper>
            </ErrorBoundary>
          </div>
        );
      }
    } else {
      return (
        <div
          style={{
            backgroundColor: uhcThemeOverride.theme.colors.bgHeaderColor,
          }}
        >
          <ErrorBoundary>
            <AlertBannerWrapper>
              <ChoosePCPAlert />
              <ExpandedSearchRadiusBanner />
              {eapCodeFlag && isBHCare && (
                <EAPStyle>
                  <EAPCode />
                </EAPStyle>
              )}
            </AlertBannerWrapper>
          </ErrorBoundary>
        </div>
      );
    }
  } else {
    return null;
  }
};
